/**
 * Storezone — Textarea
 */

import { forwardRef, type TextareaHTMLAttributes } from 'react'
import './Textarea.css'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  helperText?: string
  error?: string
  fullWidth?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, helperText, error, fullWidth = false, id, className = '', ...props }, ref) => {
    const textareaId = id ?? `sz-textarea-${Math.random().toString(36).slice(2, 9)}`
    const errorId = `${textareaId}-error`
    return (
      <div className={`sz-textarea-root ${fullWidth ? 'sz-textarea-root--full' : ''} ${className}`}>
        {label && <label htmlFor={textareaId} className="sz-textarea-label">{label}</label>}
        <textarea
          ref={ref}
          id={textareaId}
          className={`sz-textarea ${error ? 'sz-textarea--error' : ''}`}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          rows={4}
          {...props}
        />
        {error && <p id={errorId} className="sz-textarea-error" role="alert">{error}</p>}
        {!error && helperText && <p className="sz-textarea-helper">{helperText}</p>}
      </div>
    )
  },
)
Textarea.displayName = 'Textarea'
